export default __webpack_public_path__ + "static/media/Mona.00680b04.png";